import { proxyAxios } from 'api/apiBase/axios';
import { mapError } from 'api/apiBase/mapError';
import { mapResponse } from 'api/apiBase/mapResponse';

import { GeckoterminalToken } from '../types';

import { GetGeckoterminalTokenRequest } from './api.types';

export async function getGeckoterminalToken(req: GetGeckoterminalTokenRequest) {
  try {
    const url = new URL(
      `https://api.geckoterminal.com/api/v2/networks/${req.network}/tokens/${req.tokenAddress}`,
    );
    const params = new URLSearchParams();

    if (req.include) {
      params.append('include', req.include);
    }

    url.search = params.toString();

    const response = await proxyAxios.get<{ data: GeckoterminalToken }>('/api/v1/proxy', {
      params: {
        url: url.toString(),
      },
    });

    return mapResponse<GeckoterminalToken>({ data: response.data.data });
  } catch (error) {
    return mapError<GeckoterminalToken>({ error });
  }
}
